var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 65,
    viewBox: "0 0 37 65",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6863 18.3431C36.6863 28.4737 18.3431 51.0417 18.3431 51.0417C18.3431 51.0417 0 28.4737 0 18.3431C0 13.4782 1.93256 8.81257 5.37257 5.37257C8.81257 1.93257 13.4782 0 18.3431 0C23.208 0 27.8737 1.93257 31.3137 5.37257C34.7537 8.81257 36.6863 13.4782 36.6863 18.3431Z",
    fill: "url(#paint0_linear_912_478)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3431 64.28C21.074 64.28 23.2878 62.0662 23.2878 59.3353C23.2878 56.6044 21.074 54.3906 18.3431 54.3906C15.6122 54.3906 13.3984 56.6044 13.3984 59.3353C13.3984 62.0662 15.6122 64.28 18.3431 64.28Z",
    fill: "url(#paint1_linear_912_478)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7318 17.5456C26.7318 19.2041 26.24 20.8253 25.3186 22.2043C24.3972 23.5833 23.0876 24.658 21.5553 25.2927C20.0231 25.9274 18.3371 26.0934 16.7105 25.7699C15.0838 25.4463 13.5897 24.6477 12.417 23.475C11.2442 22.3023 10.4456 20.8081 10.1221 19.1815C9.79851 17.5549 9.96458 15.8689 10.5993 14.3366C11.2339 12.8044 12.3087 11.4948 13.6877 10.5734C15.0667 9.65195 16.6879 9.16016 18.3464 9.16016C19.4477 9.15965 20.5383 9.3762 21.5559 9.79743C22.5735 10.2187 23.4981 10.8363 24.2769 11.6151C25.0557 12.3938 25.6733 13.3184 26.0945 14.336C26.5158 15.3536 26.7323 16.4443 26.7318 17.5456Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_912_478",
    x1: 0,
    y1: 0,
    x2: 53.9103,
    y2: 42.3587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C94DAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_912_478",
    x1: 0,
    y1: 0,
    x2: 53.9103,
    y2: 42.3587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C94DAA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.ebf6280aa2d1045f29fc1a42e82c2b1d.svg";
export { ForwardRef as ReactComponent };